import { MutationTree } from "vuex";

import type { Auth } from "@/models/auth";

export type Mutations<S = Auth> = {
  SET_TIMEOUT(state: S, payload: string): void;
  SET_LOGIN(state: S, payload: string): void;
  SET_TOKEN(state: S, payload: string): void;
};

export const mutations: MutationTree<Auth> & Mutations = {
  SET_TIMEOUT(state: Auth, sessionTimeout: string) {
    state.sessionTimeout = sessionTimeout;
  },
  SET_LOGIN(state: Auth, login: string) {
    state.login = login;
  },
  SET_TOKEN(state: Auth, token: string) {
    state.token = token;
  },
};
